/* @ngInject */
function routes ($urlRouterProvider) {
  $urlRouterProvider.otherwise('/home')
}

export const deskfyRoutes = routes
